/**
 * Notice-and-takedown. The elements listed are the ones 17 U.S.C. §512(c)(3) requires a notice
 * to contain; leaving one out is the usual reason a notice cannot be acted on.
 */
import { pageTitle } from '@thottbot/shared';
import { Link } from 'react-router';
import { DMCA_EMAIL, OPERATOR, POLICY_UPDATED } from './contact';

export function Dmca() {
  return (
    <div className="page legal" data-testid="dmca-page">
      <title>{pageTitle('Copyright and DMCA')}</title>
      <h1>Copyright and DMCA</h1>
      <p className="muted">Last updated {POLICY_UPDATED}.</p>

      <h2>Game content</h2>
      <p>
        World of Warcraft, its data and its imagery are the property of Blizzard Entertainment,
        Inc. This site reproduces game data as a fan reference under Blizzard's fan site
        guidelines. It is not affiliated with or endorsed by Blizzard.
      </p>

      <h2>If you think something here infringes your copyright</h2>
      <p>
        Send a notice to <a href={`mailto:${DMCA_EMAIL}`}>{DMCA_EMAIL}</a>. To be actionable it
        has to contain all six of these:
      </p>
      <ol>
        <li>your physical or electronic signature;</li>
        <li>
          identification of the copyrighted work you say has been infringed (or, for several
          works at one site, a representative list);
        </li>
        <li>
          identification of the material you say is infringing, <b>with the exact URL on this
          site</b>, precise enough for us to find it;
        </li>
        <li>your address, telephone number and email address;</li>
        <li>
          a statement that you have a good-faith belief the use is not authorised by the copyright
          owner, its agent, or the law;
        </li>
        <li>
          a statement that the information in the notice is accurate and — under penalty of
          perjury — that you are the copyright owner or authorised to act for them.
        </li>
      </ol>
      <p>
        Be aware that under 17 U.S.C. §512(f) someone who knowingly misrepresents that material is
        infringing can be liable for damages, including costs and legal fees.
      </p>

      <h2>What happens next</h2>
      <p>
        {OPERATOR} will review the notice and, where it appears valid, remove or disable access to
        the material and tell whoever contributed it, passing on a copy of the notice. Accounts
        that repeatedly infringe are terminated.
      </p>

      <h2>Counter-notice</h2>
      <p>
        If your material was removed and you believe that was a mistake or a misidentification,
        send a counter-notice to the same address containing:
      </p>
      <ol>
        <li>your signature;</li>
        <li>
          identification of the removed material and where it appeared before it was removed;
        </li>
        <li>
          a statement under penalty of perjury that you have a good-faith belief it was removed as
          a result of mistake or misidentification;
        </li>
        <li>
          your name, address and telephone number, and a statement that you consent to the
          jurisdiction of a court where you live (or, if you are outside the United States, any
          judicial district in which this site may be found), and that you will accept service of
          process from the party who sent the original notice.
        </li>
      </ol>
      <p>
        We may restore the material after a statutory waiting period unless the original
        complainant tells us they have gone to court.
      </p>

      <h2>Data corrections are not a copyright matter</h2>
      <p>
        If a page is simply <i>wrong</i> rather than infringing, do not send a DMCA notice —
        editing the page or leaving a comment is faster and is what the site is for. See the{' '}
        <Link to="/terms">terms of service</Link> for how contributions are handled.
      </p>
    </div>
  );
}
